import { styled } from "@mui/material/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ARROW_SIZE = 48;
const GAP = 50;
const SMALL_SLIDE_WIDTH = 353;
const LARGE_SLIDE_WIDTH = 765;

const ArrowContainer = styled("div")(({ theme, orientation }) => {
  return {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1,
    backgroundColor: theme.palette.categorySliders.buttons.inactive,
    borderRadius: "50%",
    width: ARROW_SIZE,
    height: ARROW_SIZE,
    display: "none",
    [orientation]: `calc(
      (100vw - ${SMALL_SLIDE_WIDTH}px) / 2
      - (${ARROW_SIZE}px * 2)
      - ${GAP}px
    )`,
    [theme.breakpoints.up("mobile")]: {
      display: "flex",
      [orientation]: `calc(
        (100vw - ${LARGE_SLIDE_WIDTH}px) / 2
        - (${ARROW_SIZE}px * 2)
        - ${GAP}px
      )`,
    },
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 3px 0 rgba(37,45,95,.25)",
    "& svg": {
      width: 20,
      color: "white",
    },
    "&:hover": {
      background: theme.palette.categorySliders.buttons.active,
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
      cursor: "pointer",
    },
  };
});

const Arrows = () => {
  return (
    <>
      <ArrowContainer data-testid="left-arrow" className="category-prev-element" orientation="left">
        <ArrowForwardIosIcon sx={{ transform: "rotate(180deg)" }} />
      </ArrowContainer>

      <ArrowContainer data-testid="right-arrow" className="category-next-element" orientation="right">
        <ArrowForwardIosIcon />
      </ArrowContainer>
    </>
  );
};

export default Arrows;
